import React from 'react';

export default class SetValueCheck extends React.Component {
  
  render() {
    const comp = this.props.values.comparison;
    const algo = this.props.values.algorithm.map((val, index) => {
      const style = comp[index] ? 'digitOk' : 'digitError';
      return (<td key={index} className={style}>{val === null ? '_': val}</td>);
    });
    const setValue = this.props.values.setValue.map((val, index) => {
      const style = comp[index] ? 'digitOk' : 'digitError';
      return (<td key={index} className={style}>{val === null ? '_': val}</td>);
    });

    return (
      <div>
        <table>
          <tbody>
            <tr>
              <td>
                Algorithm:
              </td>
              {algo}
            </tr>
            <tr>
              <td>
                Set value:
              </td>
              {setValue}
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/SetValueCheck.js